import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getEvent } from '../selectors';

export const Event = ({ event }) => {
  const {
    eventName,
    eventStartDateTime,
    eventInPlay,
    eventLiveTime,
    eventPeriod,
    scoreHome,
    scoreAway,
    scoreLabel,
    subScoreHome,
    subScoreAway,
    subScoreLabel
  } = event;

  const eventPeriodAndTime = (eventPeriod && eventLiveTime)
    ? `${eventPeriod} - ${eventLiveTime}`
    : (eventPeriod || eventLiveTime);

  return (
    <div className="open-bet-event">
      <div className="open-bet-event__line">
        <div className="open-bet-event__separator" />
      </div>
      <div className="open-bet-event__line">
        <div className="open-bet-event__teams">
          {eventName}
        </div>
      </div>
      <div className="open-bet-event__line">
        {
          (eventInPlay && scoreHome !== '' && scoreAway !== '')
            ? (
              <div className="open-bet-event__live-score">
                {scoreLabel} {scoreHome}-{scoreAway}
              </div>
            )
            : null
        }
        {
          (eventInPlay && subScoreHome !== '' && subScoreAway !== '')
            ? (
              <div className="open-bet-event__live-score open-bet-event__live-score--secondary">
                {subScoreLabel} {subScoreHome}-{subScoreAway}
              </div>
            )
            : null
        }
      </div>
      {
        (eventInPlay && (eventPeriodAndTime || (scoreHome !== '' && scoreAway !== '')))
          ? (
            <div className="open-bet-event__line">
              <div className="open-bet-event__match-time">{eventPeriodAndTime}</div>
            </div>
          )
          : <div className="open-bet-event__start-time">{eventStartDateTime}</div>
      }
    </div>
  );
};

Event.propTypes = {
  event: PropTypes.shape({
    eventName: PropTypes.string.isRequired,
    eventStartDateTime: PropTypes.string.isRequired,
    eventInPlay: PropTypes.bool.isRequired,
    eventLiveTime: PropTypes.string.isRequired,
    eventPeriod: PropTypes.string.isRequired,
    scoreHome: PropTypes.string.isRequired,
    scoreAway: PropTypes.string.isRequired,
    scoreLabel: PropTypes.string.isRequired,
    subScoreHome: PropTypes.string.isRequired,
    subScoreAway: PropTypes.string.isRequired,
    subScoreLabel: PropTypes.string.isRequired
  }).isRequired,
};

const mapStateToProps = (initialState, initialProps) => (state) => ({
  event: getEvent(state, initialProps)
});

export default connect(mapStateToProps)(Event);
